<template>
  <b-row class="oscillography-analysis__filters">
    <b-col
      cols="12"
      lg="4"
    >
      <b-form-group
        class="oscillography-analysis__field"
        :label="$t('engineering.oscillography-analysis.filters.oscillographs')"
        label-for="oscillography-analysis-oscillographs"
      >
        <b-form-select
          id="oscillography-analysis-oscillographs"
          :value="selectedOscillograph"
          :options="oscillographsOptions"
          :disabled="loading || filtersDisabled"
          @input="$emit('update:selectedOscillograph', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col
      cols="12"
      lg="4"
    >
      <b-form-group
        class="oscillography-analysis__field"
        :label="$t('engineering.oscillography-analysis.filters.maneuver-types')"
        label-for="oscillography-analysis-maneuver-types"
      >
        <b-form-select
          id="oscillography-analysis-maneuver-types"
          :value="selectedManeuverType"
          :options="maneuverTypeOptions"
          :disabled="loading || filtersDisabled || maneuverTypeDisabled"
          @input="$emit('update:selectedManeuverType', $event)"
        />
      </b-form-group>
    </b-col>

    <b-col
      cols="12"
      lg="4"
    >
      <b-form-group
        class="oscillography-analysis__field"
        :label="$t('engineering.oscillography-analysis.filters.module-phase')"
        label-for="oscillography-analysis-module-phase"
      >
        <b-form-select
          id="oscillography-analysis-module-phase"
          :value="selectedModulePhase"
          :options="modulePhaseOptions"
          :disabled="loading || filtersDisabled"
          @input="$emit('update:selectedModulePhase', $event)"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'OscillographyAnalysisFilters',
  props: {
    selectedOscillograph: {
      type: String,
      default: 'last-10',
    },
    selectedManeuverType: {
      type: String,
      default: 'opening',
    },
    maneuverTypeDisabled: {
      type: Boolean,
      default: false,
    },
    selectedModulePhase: {
      type: String,
      default: null,
    },
    oscillographsOptions: {
      type: Array,
      default: () => [],
    },
    maneuverTypeOptions: {
      type: Array,
      default: () => [],
    },
    modulePhaseOptions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    filtersDisabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
